
$( document ).ready(function() {
	$( ".faq-item" ).click(function() {
		
		$('.material-icons', this).toggleClass('active');
		
		// $( ".faq-answer", this ).toggle( "fade", function() {
		// 	// Animation complete.
		// });
	});
});